export const blockIconsPhotoandimageCropFreeNew = (
	<span className='material-symbols-outlined'>crop_free</span>
);
